export default __webpack_public_path__ + "static/media/18.7c89a61c.jpg";